import React, { FC } from 'react';
import { Button } from 'antd';
import styles from './index.module.css';
import { FolderUp } from 'lucide-react';
import { View } from '../project_board/project_nav/types';
import cx from 'classnames';

type Props = {
  hasTasks: boolean;
  hasSitesOrFiles: boolean;
  loading: boolean;
};

enum EmptyStateView {
  TASKS = 'tasks',
  SITES = 'sites'
}

const FEEDBACK_INDEX = 1;

export const EmptyState: FC<Props> = ({
  hasTasks,
  hasSitesOrFiles,
  loading
}) => {
  if (loading || hasTasks) return null;

  const emptyStateView = hasSitesOrFiles
    ? EmptyStateView.TASKS
    : EmptyStateView.SITES;
  const showSites = emptyStateView === EmptyStateView.SITES;
  const header = showSites
    ? "Where's my feedback? 🤔"
    : 'This board is spotless 🧹';
  const message = showSites
    ? 'Before you can create or gather feedback, you need to add a Website or File to your project.'
    : [
        'When tasks appear in ',
        'Feedback',
        ' move them to this Task Board when they are ready to be actioned and managed.'
      ];

  return (
    <div className={styles.emptyState}>
      <h3 className={styles.header}>{header}</h3>
      <p className={styles.message}>
        {typeof message === 'string'
          ? message
          : message.map((part: string, index: number) =>
              index === FEEDBACK_INDEX ? (
                <strong
                  onClick={() =>
                    // @ts-expect-error
                    window.project_board_props?.setView(View.Triage)
                  }
                >
                  {part}
                </strong>
              ) : (
                part
              )
            )}
      </p>
      {showSites && (
        <Button
          type="primary"
          onClick={() => {
            // @ts-expect-error
            window.project_board_props?.showAssets(View.Assets);
          }}
          icon={<FolderUp className={styles.folderIcon} />}
          className={styles.button}
        >
          Go to Websites & Files
        </Button>
      )}
      <div className={cx(styles.imageContainer, styles[emptyStateView])} />
    </div>
  );
};
